import React from 'react';
import { TextField } from '@mui/material';

import { FormInputProps as Props } from '@occc-app/design-system';

export interface IProps {
  isValid?: boolean;
  max?: string | number;
  readonly?: boolean;
  helpText?: string;
  errorText?: string;
  label?: string;
}

export type FormInputProps = Props;

export const FormInput: React.FC<FormInputProps> = ({
  isValid = true,
  readonly = false,
  max,
  helpText,
  errorText,
  inputProps = {},
  ...props
}) => {
  return (
    <TextField
      helperText={errorText || helpText}
      inputProps={{ ...inputProps, max }}
      InputProps={{ readOnly: readonly }}
      error={!isValid}
      fullWidth={true}
      variant='outlined'
      margin='normal'
      {...props}
    />
  );
};
